import styled from 'styled-components';
import Triangle from './Triangle';

const Container = styled.div`
  position: absolute;
  min-width: 240px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  cursor: default;

  &.top-right {
    right: -11px;
    top: 100%;
    margin-top: 20px;

    ${Triangle} {
      bottom: 100%;
      right: 6px;

      &:after {
        top: 30px;
        right: 5px;
      }
    }
  }

  &.top-left {
    left: -11px;
    top: 100%;
    margin-top: 20px;

    ${Triangle} {
      bottom: 100%;
      left: 6px;

      &:after {
        top: 30px;
        left: 5px;
      }
    }
  }

  &.bottom-right {
    right: -11px;
    top: 100%;
    margin-top: 20px;

    ${Triangle} {
      bottom: 100%;
      right: 6px;

      &:after {
        top: 30px;
        right: 5px;
      }
    }
  }

  &.bottom-left {
    left: -11px;
    top: 100%;
    margin-top: 20px;

    ${Triangle} {
      bottom: 100%;
      left: 6px;

      &:after {
        top: 30px;
        left: 5px;
      }
    }
  }

  &.left-top {
    left: 100%;
    top: -11px;
    margin-left: 20px;

    ${Triangle} {
      right: 100%;
      top: 6px;

      &:after {
        top: 5px;
        left: 30px;
      }
    }
  }

  &.left-bottom {
    left: 100%;
    bottom: -11px;
    margin-left: 20px;

    ${Triangle} {
      right: 100%;
      bottom: 6px;

      &:after {
        bottom: 5px;
        left: 30px;
      }
    }
  }

  &.right-top {
    right: 100%;
    top: -11px;
    margin-right: 20px;

    ${Triangle} {
      left: 100%;
      top: 6px;

      &:after {
        top: 5px;
        right: 30px;
      }
    }
  }

  &.right-bottom {
    right: 100%;
    bottom: -11px;
    margin-right: 20px;

    ${Triangle} {
      left: 100%;
      bottom: 6px;

      &:after {
        bottom: 5px;
        right: 30px;
      }
    }
  }
`;

export default Container;


// WEBPACK FOOTER //
// ./src/app/admin/components/Hotspot/Modal/Container.js